module.exports = __webpack_public_path__ + "img/D&D-Elemente_Quadrat_Kapitel4.7b0af235.svg";